module.exports = __webpack_public_path__ + "static/media/yash.5a13fc7f.png";